/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 28.04.2016.
 */

import React, {Component, PropTypes} from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import ClassNames from 'classnames';

import _get from 'lodash/get';

import MovieTile from './Movie/movie-tile';
import ChannelTile from './Channel/channel-tile';
import NpvrTile from './Npvr/npvr-tile';
import Notification from './Notification/notification-tile';
import TvSeries from './TvSeries/tv-series-tile';
import Package from './Package/package-tile';
import Subscription from './Subscription/subscription-tile';

class Tile extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  _renderTile() {

    switch (true) {
      case _get(this.props.asset, 'type') === 'movie':
        return (<MovieTile movie={this.props.asset} onMovieSelect={this.props.onAssetSelect} row={this.props.row} col={this.props.col} isSelected={this.props.isSelected}/>);

      case _get(this.props.asset, 'type') === 'channel':
        return (<ChannelTile channel={this.props.asset} onChannelSelect={this.props.onAssetSelect} row={this.props.row} col={this.props.col} isSelected={this.props.isSelected}/>);

      case _get(this.props.asset, 'type') === 'npvr':
        return (<NpvrTile record={this.props.asset} onRecordSelect={this.props.onAssetSelect} row={this.props.row} col={this.props.col} isSelected={this.props.isSelected}/>);

      case _get(this.props.asset, 'type') === 'notification':
        return (<Notification notification={this.props.asset} onNotificationSelect={this.props.onAssetSelect} row={this.props.row} col={this.props.col} isSelected={this.props.isSelected}/>);

      case _get(this.props.asset, 'type') === 'package' && _get(this.props.asset, 'package_type') === 'tv_series':
        return (<TvSeries tvSeries={this.props.asset} onTvSeriesSelect={this.props.onAssetSelect} row={this.props.row} col={this.props.col} isSelected={this.props.isSelected}/>);

      case _get(this.props.asset, 'type') === 'package' && _get(this.props.asset, 'package_type') === 'generic':
        return (<Package pckage={this.props.asset} onPackageSelect={this.props.onAssetSelect} row={this.props.row} col={this.props.col} isSelected={this.props.isSelected}/>);

      case _get(this.props.asset, 'type') === 'subscription':
        return (<Subscription subscription={this.props.asset} onSubscriptionSelect={this.props.onAssetSelect} row={this.props.row} col={this.props.col} isSelected={this.props.isSelected}/>);

      default:
        let defaultTileClass = ClassNames({
          'col-last': this.props['col'] === 8,
          'movie block-1 bg-black radius showcase-row-movie-block': true
        });

        return (
          <div className={defaultTileClass}>
            <a className="movie-link profile-show col hover">
              {_get(this.props, 'asset.title')}
            </a>
          </div>
        );
    }
  }

  render() {

    return (
      <ReactCSSTransitionGroup transitionName="tile-animation" transitionAppear={true} transitionAppearTimeout={0} transitionEnterTimeout={0} transitionLeaveTimeout={0}>
        {this._renderTile()}
      </ReactCSSTransitionGroup>
    );
  }
}

Tile.propTypes = {
  asset: PropTypes.object
};

export default Tile;



// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/Tile/index.js